import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UiModule } from '@app/ui';
import { UIState } from '@app/ui/states/ui.state';
import { TranslatePipe } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-app-name-section',
  templateUrl: './app-name-section.component.html',
  styleUrl: './app-name-section.component.scss',
  standalone: true,
  imports: [AsyncPipe, TranslatePipe, UiModule],
})
export class AppNameSectionComponent {
  @Select(UIState.isCreationProcess) isCreationProcess$: Observable<boolean>;
  @Input() appName = '';
  @Output() readonly appNameChange = new EventEmitter<string>();

  onAppNameChange(newName: string) {
    this.appNameChange.emit(newName);
  }
}
